import { Text } from "@mantine/core";

import type { MantineSize, MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type ListTablePageSizeLabelProps = {
  label?: string;
  size?: MantineSize;
  value: number;
} & MantineStyleProps;

export const ListTablePageSizeLabel: FC<ListTablePageSizeLabelProps> = ({
  label,
  size,
  value,
  ...props
}) => (
  <Text size={size} style={{ whiteSpace: "nowrap" }} {...props}>
    <Text component="span" fw={500}>
      {value}
    </Text>
    {label && (
      <Text component="span" c="secondary.5">
        {label}
      </Text>
    )}
  </Text>
);
